/* Complementary variants controller (Trade compatible) */
window.CompVariants = (function () {
  function getCartElement() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer') || null;
  }

  function bindQtySteppers(scope) {
    scope.querySelectorAll('.comp-form').forEach((form) => {
      const input = form.querySelector('.comp-qty__input');
      if (!input) return;

      const decr = form.querySelector('[data-decr]');
      const incr = form.querySelector('[data-incr]');

      const clamp = () => {
        const min = Number(input.getAttribute('min') || 1);
        const maxAttr = input.getAttribute('max');
        const max = maxAttr ? Number(maxAttr) : null;
        let val = parseInt(input.value || '1', 10);
        if (isNaN(val) || val < min) val = min;
        if (max !== null && val > max) val = max;
        input.value = String(val);
      };

      decr && decr.addEventListener('click', () => {
        input.value = String(Math.max((parseInt(input.value || '1', 10) || 1) - 1, Number(input.min || 1)));
        clamp();
      });
      incr && incr.addEventListener('click', () => {
        const step = Number(input.step || 1);
        input.value = String((parseInt(input.value || '1', 10) || 1) + step);
        clamp();
      });
      input.addEventListener('change', clamp);
      input.addEventListener('input', () => {
        input.value = input.value.replace(/[^\d]/g, '');
      });
    });
  }

  function bindAjaxAdd(scope) {
    scope.querySelectorAll('.comp-form[data-ajax-form]').forEach((form) => {
      if (form.__compBound) return;
      form.__compBound = true;

      form.addEventListener('submit', async (e) => {
        e.preventDefault();

        const variantId = form.querySelector('input[name="id"]')?.value;
        const qtyInput = form.querySelector('input[name="quantity"]');
        const qty = qtyInput ? Number(qtyInput.value || '1') : 1;

        if (!variantId) {
          showInlineError(form, window.variantStrings?.unavailable || 'Veuillez choisir une option.');
          return;
        }

        const addBtn = form.querySelector('.comp-add');
        const spinner = addBtn?.querySelector('.loading__spinner');

        const cart = getCartElement();

        try {
          addBtn?.setAttribute('aria-disabled', 'true');
          addBtn?.setAttribute('disabled', 'disabled');
          addBtn?.classList.add('loading');
          spinner && spinner.classList.remove('hidden');

          const fd = new FormData();
          fd.append('id', String(variantId));
          fd.append('quantity', String(qty));

          // IMPORTANT pour Trade: sections + sections_url
          if (cart?.getSectionsToRender) {
            try {
              fd.append('sections', cart.getSectionsToRender().map((s) => s.id));
            } catch {}
            fd.append('sections_url', window.location.pathname);
            cart.setActiveElement?.(document.activeElement);
          }

          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: fd
          });

          const json = await res.json();

          if (!res.ok || json?.status) {
            const msg = json?.errors || json?.description || json?.message || 'Impossible d’ajouter au panier.';
            showInlineError(form, (typeof msg === 'string') ? msg : 'Erreur.');
            return;
          }

          // Rafraîchir le cart Trade
          if (cart?.renderContents) {
            cart.renderContents(json);
          }

        } catch (err) {
          console.error('[comp-variants] add error', err);
          showInlineError(form, 'Une erreur est survenue. Réessayez.');
        } finally {
          addBtn?.removeAttribute('aria-disabled');
          addBtn?.removeAttribute('disabled');
          addBtn?.classList.remove('loading');
          spinner && spinner.classList.add('hidden');
        }
      });
    });
  }

  function showInlineError(form, message) {
    if (!form) return;
    let wrap = form.querySelector('.product-form__error-message-wrapper');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'product-form__error-message-wrapper';
      form.appendChild(wrap);
    }
    let msg = wrap.querySelector('.product-form__error-message');
    if (!msg) {
      msg = document.createElement('div');
      msg.className = 'product-form__error-message';
      msg.setAttribute('role', 'alert');
      wrap.appendChild(msg);
    }
    msg.textContent = message;
    wrap.removeAttribute('hidden');
  }

  function mount() {
    document.querySelectorAll('[data-comp-root]').forEach((root) => {
      bindQtySteppers(root);
      bindAjaxAdd(root);
    });
  }

  document.addEventListener('DOMContentLoaded', mount);
  document.addEventListener('shopify:section:load', mount);

  return { mount };
})();
